var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5 53.68C45.3234 53.68 57.34 41.6633 57.34 26.84C57.34 12.0167 45.3234 0 30.5 0C15.6767 0 3.66003 12.0167 3.66003 26.84C3.66003 35.1865 7.46985 42.6432 13.4453 47.5659C13.4549 47.5738 13.4464 47.589 13.4347 47.585C13.4275 47.5826 13.4201 47.5879 13.4201 47.5955V54.5042C13.4201 57.4834 16.5602 59.4171 19.2206 58.076L27.1287 54.0896C27.7922 53.7551 28.5354 53.6194 29.2776 53.6527C29.6828 53.6708 30.0904 53.68 30.5 53.68Z",
    fill: "#2151C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6227 19.5614C39.3839 20.1451 39.5292 21.2348 38.9475 21.9975L30.315 33.3158C30.0106 33.7149 29.5493 33.9629 29.0493 33.9962C28.5493 34.0294 28.0593 33.8448 27.705 33.4895L22.2259 27.996C21.5484 27.3167 21.5484 26.2171 22.2259 25.5377C22.9061 24.8558 24.0107 24.8558 24.6908 25.5377L28.7594 29.617L36.1804 19.8871C36.7642 19.1216 37.8587 18.9757 38.6227 19.5614Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.8fd996103b5bd752d3f709db77a21ad6.svg";
export { ForwardRef as ReactComponent };